<template>
    <router-link :to="route" :class="{ 'is-active': isActive }" @click="closeMenu"> Gradebook Preview </router-link>
</template>

<script>
import Course from '@/models/Course.js';
import CourseTemplate from '@/models/CourseTemplate.js';

export default {
    name: 'GradebookPreview',

    props: {
        closeMenu: {
            type: Function,
            default: () => {},
        },

        course: {
            required: true,
            type: [Course, CourseTemplate],
        },
    },

    computed: {
        isCourseTemplate() {
            return this.$route.name.includes('template');
        },

        isActive() {
            return (
                this.$route.name === 'course-gradebook-preview' ||
                this.$route.name === 'course-template-gradebook-preview'
            );
        },

        route() {
            if (this.course instanceof CourseTemplate) {
                return {
                    name: 'course-template-gradebook-preview',
                    params: {
                        id: this.course.id,
                    },
                };
            }

            return {
                name: 'course-gradebook-preview',
                params: {
                    courseId: this.course.id,
                },
            };
        },
    },
};
</script>
